var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotypeJp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 24,
    viewBox: "0 0 68 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.949 17.303V2H1.747v5.47h10.42v9.833H0v5.745h22.483v-5.745H17.95ZM68 15.95v-5.744H47.35v5.745h7.48v7.097h5.695V15.95H68ZM55.958 2v5.47h-8.607V2h8.607ZM68 7.47V2h-3.902v5.47H68ZM62.066 2v5.47h-3.903L58.178 2h3.888ZM42.241 17.303V2H26.039v5.47h10.42v9.833H24.8v5.745h21.976v-5.745H42.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeJp);
export default __webpack_public_path__ + "static/media/logotype_jp.da61d801484080112a08838dc0fcb0b9.svg";
export { ForwardRef as ReactComponent };